export default {
  options: {
    true: 'Ja',
    false: 'Nej',
  },
};
